// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__vPESl","outline":"styles_outline__Le_o6"};